export const InvalidCharacters = ["\\", "/", "#", "%", "?", "&", "*", "+", "|", ":", "<", ">", '"', "'"];
export const TableNameInvalidCharacters = [
    "'",
    '"',
    ";",
    "\\",
    "[",
    "]",
    "{",
    "}",
    "?",
    "<",
    ">",
    "!",
    "@",
    "#",
    "^",
    "&",
    "*"
];
export const PathOperators = [".", ".."];

export const DefaultAllowedExtensions = [
    "docx",
    "xlsx",
    "csv",
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "gif",
    "tif",
    "tiff",
    "bmp"
];

export const ItemNameMaxLength = 128;

export const TableNameMaxLength = 510;
